import { jsx as _jsx } from "react/jsx-runtime";
import { Footer, Header, loadConfigAsync, } from "@aviv-header-footer/components";
import { createErrorMessage, createShellLikeId, } from "@aviv-unified-frontend/internal";
import { STAGE_LIKE_ENVIRONMENT } from "../../src/constants/environment";
export const createB2CBrand = (input) => {
    // TODO: Remove exclusion when auth will be setup for SLN
    if (!input.authentication && input.id !== "sln") {
        throw new Error(createErrorMessage({
            cause: "Authentication configuration is required for B2C brands (except SLN)",
            solution: "Please add the authentication configuration key to the brand configuration",
        }));
    }
    if (!input.qualtrics && input.id !== "sln") {
        throw new Error(createErrorMessage({
            cause: "Qualtrics configuration is required for B2C brands (except SLN)",
            solution: "Please add the Qualtrics configuration key to the brand configuration",
        }));
    }
    return {
        ...input,
        type: "b2c",
        layout: createB2CLayout(input),
        identityProvider: createIdentityProvider(),
    };
};
const createB2CLayout = (input) => {
    return {
        Header: ({ headerFooterConfig, layoutMode }) => (_jsx(Header, { config: headerFooterConfig ?? {}, testId: createShellLikeId("header"), layoutMode: layoutMode })),
        Footer: ({ headerFooterConfig, layoutMode }) => (_jsx(Footer, { config: headerFooterConfig ?? {}, testId: createShellLikeId("footer"), layoutMode: layoutMode })),
        getHeaderFooterConfig: (languageTag) => getHeaderFooterConfig(input.portal, languageTag),
    };
};
const getHeaderFooterConfig = async (portal, languageTag) => {
    return loadConfigAsync(portal, STAGE_LIKE_ENVIRONMENT, languageTag);
};
/**
 * Creates an identity provider for B2C brand to fulfill the AuthenticationContext contract.
 *
 * @remarks
 * This function returns an object with a `Component` that simply renders its children.
 * The `useAuthenticated` property is intentionally set to `undefined` because currently there is no identity provider in B2C.
 *
 * @returns An object with a `Component` and `useAuthenticated` properties.
 */
const createIdentityProvider = () => {
    return {
        Component: ({ children }) => {
            return children;
        },
        useAuthenticated: undefined,
    };
};
